import { InputSearch } from 'basic-ui-lib';
import { IPlaylist } from 'modules/playlist/interfaces/api';
import PlaylistItemMobile from 'modules/playlist/screens/Dashboard/components/PlaylistItemMobile';
import styled from 'styled-components';

interface StorePlaylistsProps {
  playlists: IPlaylist[];
}

const StorePlaylists = ({ playlists }: StorePlaylistsProps) => {
  return (
    <Container>
      <InputSearch placeholder='Search playlist name' />
      {playlists?.map((playlist) => (
        <PlaylistItemMobile key={playlist.id} item={playlist} />
      ))}
    </Container>
  );
};

export default StorePlaylists;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
`;
